import { ApiRequestStore } from '../../../common/apiRequest.store'

class CreatePlatformStore extends ApiRequestStore {}

export const createPlatformStore: CreatePlatformStore = new CreatePlatformStore()
